import { render, staticRenderFns } from "./GoodsDetailModal.vue?vue&type=template&id=c2cf6102&scoped=true&"
import script from "./GoodsDetailModal.vue?vue&type=script&lang=ts&"
export * from "./GoodsDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsDetailModal.vue?vue&type=style&index=0&id=c2cf6102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cf6102",
  null
  
)

export default component.exports